module.exports = __webpack_public_path__ + "8cfa6b4921f80236e9333f7c3820e610.svg";